<template>
  <div class="content">
    <!-- 快捷菜单 -->
    <div class="gundong" v-if="ExpireTime <= 30">
      <marquee bgcolor="#6fb5fa" direction="left">
        <div style="font-size: 20px;">
          您的系统有效期剩余{{
            ExpireTime
          }}天，请尽快联系服务商续费延期，以免突然停止支付，影响站上收款.
        </div>
      </marquee>
    </div>
    <div class="topBox">
      <div class="shortcutMenu">
        <p class="headline">快捷菜单</p>
        <div class="menuCont">
          <div
            class="option"
            v-for="(item, index) in menuData"
            :key="index"
            @click="gotoLink(item.url)"
          >
            <el-badge
              class="item"
              :hidden="item.title != '现金待确认' || cashTotal == 0"
              :value="cashTotal"
            >
              <div class="details">
                <img :src="item.imgUrl" alt />
              </div>
              <p>{{ item.title }}</p>
            </el-badge>
          </div>
        </div>
      </div>
      <!-- 客服，过期 -->
      <div class="topBox_left">
        <div class="service">
          <div class="top">
            <img src="@public/img/vipImg/service.png" alt />
            <div class="top_left">
              <div>在线客服</div>
              <div>电话：{{ show_mobile }}</div>
            </div>
          </div>
          <div class="broadcast">
            <img
              class="erweima"
              style="width: 90px; height: 90px;"
              src="https://yckj-common.oss-cn-beijing.aliyuncs.com/1617013101.png"
              alt
            />
            <div class="ziti">扫码下载APP</div>
          </div>
          <div class="bottom">
            <div @click="downLoad">
              <img src="@public/img/broadcast.png" alt />
              语音播报下载
            </div>
            <div @click="downLoad2">
              <img src="@public/img/assist.png" alt />
              远程工具下载
            </div>
            <!-- <el-button type="primary" icon="el-icon-download">语音播报下载</el-button> -->
          </div>
        </div>
        <!-- <div class="line"></div>
        <div class="past" v-if="false">
          <div>{{mealName}}</div>
          <div>
            <p>
              剩余
              <span>{{lastTime}}{{lastUnit}}</span>
            </p>
            <p v-if="expire">（已到期）</p>
          </div>
          <div v-if="upcoming">
            即将到期，为保证正常使用请及时续费。
          </div>
          <div @click="showRenew=true">
            立即续费
          </div>
        </div>-->
      </div>
    </div>
    <div class="modules">
      <!-- 基础统计 -->
      <div class="lft">
        <div class="statistics">
          <div class="headline">
            <p>
              基础统计
              <!-- <span class="colorFont">更多></span> -->
            </p>
            <el-radio-group
              v-model="radioCountDay"
              size="small"
              @change="changeCountDay"
            >
              <el-radio-button label="1">今日</el-radio-button>
              <!-- <el-radio-button label="7">近七天</el-radio-button>
              <el-radio-button label="30">近30天</el-radio-button> -->
            </el-radio-group>
          </div>
          <div class="cont">
            <!-- 改统计样式 -->
            <div class="cont_item_box">
              <div class="cont_item_title">新增会员数量</div>
              <div class="cont_item_value">
                <div class="item_value_part">
                  <span>{{ baseData.member || 0 }}</span>
                  人
                </div>
              </div>
            </div>
            <div class="cont_item_box">
              <div class="cont_item_title">会员充值金额</div>
              <div class="cont_item_value">
                <div class="item_value_part">
                  <span>{{ baseData.recharge || 0 }}</span>
                  元
                </div>
              </div>
            </div>
            <div class="cont_item_box">
              <div class="cont_item_title">综合收入</div>
              <div class="cont_item_value">
                <div class="item_value_part">
                  <span>{{ baseData.income || 0 }}</span>
                  元
                </div>
              </div>
            </div>
            <div class="cont_item_box">
              <div class="cont_item_title">短信发送量</div>
              <div class="cont_item_value">
                <div class="item_value_part">
                  <span>{{ baseData.sms || 0 }}</span>
                  条
                </div>
              </div>
            </div>
            <div class="cont_item_box2">
              <div class="cont_item_title">汽油销售数据</div>
              <div class="cont_item_value2">
                <div class="item_value_part">
                  <div>金额</div>
                  <div>
                    <span>{{ baseData.goods[0].money || 0 }}</span>
                    元
                  </div>
                </div>
                <div class="bdline"></div>
                <div class="item_value_part">
                  <div>升数</div>
                  <div>
                    <span>{{ baseData.goods[0].num || 0 }}</span>
                    升
                  </div>
                </div>
                <div class="bdline"></div>
                <div class="item_value_part">
                  <div>单数</div>
                  <div>
                    <span>{{ baseData.goods[0].count || 0 }}</span>
                    单
                  </div>
                </div>
              </div>
            </div>
            <div class="cont_item_box2">
              <div class="cont_item_title">柴油销售数据</div>
              <div class="cont_item_value2">
                <div class="item_value_part">
                  <div>金额</div>
                  <div>
                    <span>{{ baseData.goods[1].money || 0 }}</span>
                    元
                  </div>
                </div>
                <div class="bdline"></div>
                <div class="item_value_part">
                  <div>升数</div>
                  <div>
                    <span>{{ baseData.goods[1].num || 0 }}</span>
                    升
                  </div>
                </div>
                <div class="bdline"></div>
                <div class="item_value_part">
                  <div>单数</div>
                  <div>
                    <span>{{ baseData.goods[1].count || 0 }}</span>
                    单
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 系统提醒 -->

        <div class="statistics system">
          <div class="headline">
            <p>系统提醒</p>
          </div>
          <template>
            <el-tabs v-model="activeName" type="card">
              <el-tab-pane label="用户管理" name="first">
                <div class="tags">
                  <template v-for="(item, index) in tagsData">
                    <el-tag
                      :key="index"
                      :color="item.color"
                      @click="tagClick(item.type, item.value)"
                    >
                      {{ item.title }}
                    </el-tag>
                  </template>
                </div>
                <template>
                  <el-table :data="tableData" border>
                    <el-table-column
                      type="selection"
                      width="55px;"
                      align="center"
                    ></el-table-column>
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column
                      prop="mobile"
                      label="手机号"
                    ></el-table-column>
                    <el-table-column
                      prop="birthday"
                      label="生日"
                    ></el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
      <div class="rgt">
        <div class="top">
          <div class="todaysales">
            <div class="headline">
              <img src="@public/img/vipImg/zongxiaoliang.png" alt />
              <span>今日总销量</span>
            </div>
            <div class="todaysales-cont">
              <template v-for="(item, index) in salesvolume">
                <div :key="index">
                  <p>
                    <img :src="item.img" alt />
                    {{ item.text }}
                  </p>
                  <p class="colorBule">{{ item.num || 0 }}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="todaysales pay">
            <div class="todaysales-cont">
              <template v-for="(item, index) in payNum">
                <div :key="index">
                  <p :style="`background:url(${item.img})`">{{ item.text }}</p>
                  <p class="colorBule">{{ item.num || 0 }}</p>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="btm">
          <div class="headline">系统公告</div>
          <div class="smallhead">最新公告</div>
          <div v-for="(item, index) in gonggaoList" :key="index" class="cont">
            <div class="ggCont">{{ item.title }}</div>
            <div class="ggHint" @click="see_info(item)">点击查看></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 微信嗎放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 判断是否有门店 -->
    <Judge :show="showJudge" @gotoNext="gotoNext()"></Judge>
    <!-- 续费窗口 -->
    <el-dialog
      :visible.sync="showRenew"
      @close="showRenew = false"
      title="续费套餐"
      width="500px"
    >
      <div
        class="meal_item_box"
        v-for="item in mealList"
        :key="item.id"
        @click="payQrcode(item)"
      >
        <div class="meal_item_title">
          {{ item.name }}
          <span class="meal_item_times">({{ item.time }}天)</span>
        </div>
        <div class="meal_item_price">￥{{ item.price }}</div>
      </div>
    </el-dialog>
    <!-- 续费二维码弹窗 -->
    <el-dialog
      :visible.sync="showQrcode"
      width="340px"
      title="扫码支付"
      @close="closeCode()"
    >
      <div class="qrcode_box" id="qrcode" ref="qrcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import Judge from "@/components/vip/judgeDialog";
import {
  baseCount,
  birthdayCount,
  checkStatus,
  getExpireTime,
  getMeal,
  todayCount,
  vipOrderList,
} from "@/api/vip";
import { selectStoreList } from "@/api/storeManage";
import { get_search_biz_user_id } from "@/api/set";
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import { BASE_URL } from "@/utils/request";
import { noticeList } from "@/api/user";

export default {
  data() {
    return {
      tableData: [],
      show_mobile: "",
      activeName: "first",
      radioCountDay: "1",
      dialogVisible: false,
      dialogImageUrl: "",
      tagsData: [
        {
          title: "今天过生日的会员",
          color: "#51ADFF",
          type: "search",
          value: "1",
        },
        {
          title: "未来三天过生日的会员",
          color: "#FF5E6E",
          type: "search",
          value: "3",
        },
        {
          title: "未来七天过生日的会员",
          color: "#6C85FF",
          type: "search",
          value: "7",
        },
        { title: "发送短信", color: "#FF7B55", type: "sendMsg", value: "1" },
        {
          title: "发送优惠券",
          color: "#72BDFF",
          type: "sendCoupon",
          value: "1",
        },
      ],
      payNum: [
        {
          text: "银联支付",
          num: "0",
          img: require("../../../../../public/img/vipImg/ylzf.png"),
        },
        {
          text: "余额支付",
          num: "0",
          img: require("../../../../../public/img/vipImg/yezf.png"),
        },
        {
          text: "现金支付",
          num: "0",
          img: require("../../../../../public/img/vipImg/xj.png"),
        },
      ],
      salesvolume: [
        {
          text: "金额",
          num: "0",
          img: require("../../../../../public/img/vipImg/price.png"),
        },
        {
          text: "升数",
          num: "0",
          img: require("../../../../../public/img/vipImg/zongshengsu.png"),
        },
        {
          text: "单数",
          num: "0",
          img: require("../../../../../public/img/vipImg/dingdanshu.png"),
        },
      ],
      menuData: [],
      baseData: {
        //基础统计
        member: "0",
        rechange: "0",
        income: "0",
        sms: "0",
        goods: [
          { money: "0", num: "0", count: "0" },
          { money: "0", num: "0", count: "0" },
        ],
      },
      showJudge: false,
      showRenew: false, //续费窗口
      mealList: [], //套餐列表
      mealName: "", // 套餐名称
      lastTime: "", //剩余时间
      lastUnit: "天", // 剩余时间单位
      expire: false, // 石否已到期
      upcoming: false, // 是否即将到期
      showQrcode: false, // 二维码弹窗
      nonce: "", // 查询订单状态唯一码
      qrcode: "", // 付款二维码链接
      cashTotal: 0,
      gonggaoList: [],
      tlPaysearchs: [],
      ExpireTime: 0,
    };
  },
  computed: {
    ...mapGetters(["token", "app_id", "status", "publicData"]),
  },
  watch: {
    publicData(val) {
      this.show_mobile = val.a_mobile;
    },
  },
  methods: {
    async getdata() {
      this.cashLoading = true;
      let data = {
        app_id: this.app_id,
        pay_status: "1",
        payment_code: "cash",
      };
      const res = await vipOrderList(data);
      this.cashTotal = res.total;
    },
    downLoad() {
      this.$confirm("确定要下载语音播报吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url =
            BASE_URL +
            "/api/config.loudspeaker/download?token=" +
            this.token +
            "&app_id=" +
            this.app_id +
            "&filename=语音报单.exe";
          // console.log("拼接链接", url);
          window.location.href = url;
        })
        .catch();
    },
    async get_gonggaoList() {
      const res = await noticeList({ app_id: this.app_id });
      if (res.code == 200) {
        console.log(res);
        this.gonggaoList = res.data;
      }
    },
    see_info(item) {
      this.$router.push({
        path: "noticeInfo",
        query: {
          id: item.id,
        },
      });
    },
    downLoad2() {
      this.$confirm("确定要下载远程工具吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url =
            BASE_URL +
            "/api/config.loudspeaker/download?token=" +
            this.token +
            "&app_id=" +
            this.app_id +
            "&filename=远程工具.exe";
          // console.log("拼接链接", url);
          window.location.href = url;
        })
        .catch();
    },
    getData() {
      //基础统计
      get_search_biz_user_id({ app_id: this.app_id }).then((res) => {
        console.log(res);
        let biz_user_ids = res.data.biz_user_ids.join(",");
        var data = {
          token: this.token,
          app_id: this.app_id,
          daynum: this.radioCountDay,
          biz_user_ids: res.data.biz_user_ids.join(","),
        };
        baseCount(data).then((res) => {
          console.log("2222", res);
          if (res.code == 200) {
            this.baseData = Object.assign({}, res.data);
            res.data.goods.forEach((item) => {
              if (item.type == "汽油") {
                this.baseData.goods[0] = item;
              } else if (item.type == "柴油") {
                this.baseData.goods[1] = item;
              }
            });
          }
          this.getTodayData(biz_user_ids);
        });
      });
    },
    getTodayData(biz_user_ids) {
      var data = {
        token: this.token,
        app_id: this.app_id,
        biz_user_ids: biz_user_ids,
      };
      todayCount(data).then((res) => {
        console.log("22221122", res);
        if (res.code == 200) {
          this.salesvolume[0].num = res.data.money || 0; //金额
          this.salesvolume[1].num = res.data.num || 0; //升数
          this.salesvolume[2].num = res.data.order || 0; //单数
          this.payNum[0].num = res.data.unionpay || 0;
          this.payNum[1].num = res.data.balance || 0;
          this.payNum[2].num = res.data.cash || 0;
        }
      });
    },
    getBirthdayData(val) {
      var data = {
        token: this.token,
        app_id: this.app_id,
        day: val || "1",
      };
      birthdayCount(data).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data;
        } else {
          if (res.code == 400) {
            this.tableData = res.data;
          }
        }
      });
    },
    gotoLink(url) {
      //顶部快捷功能
      if (url) {
        this.$router.push(url);
      }
    },
    changeCountDay() {
      //切换基础统计天数
      this.getData();
    },
    tagClick(type, value) {
      //生日统计tag按钮
      console.log(type, value);
      if (type == "search") {
        //查询统计
        this.getBirthdayData(value);
      } else if (type == "sendMsg") {
        //发送短信
        this.sendMsg();
      } else if (type == "sendCoupon") {
        //发送优惠券
        this.sendCoupon();
      }
    },
    sendMsg() {},
    sendCoupon() {},
    init() {
      //先判断有没有店铺 没有的话提示跳转创建店铺
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      selectStoreList(data).then((res) => {
        if (res.code == 400) {
          this.showJudge = true;
        } else {
          this.getData();
          // this.getTodayData()
          this.getBirthdayData();
        }
      });
      this.getMealMsg();
    },
    gotoNext() {
      //没有创建店铺 下一步前往创建
      this.$router.push("/apply/newVip/13/shop/shopList");
    },
    // 获取续费信息
    getMealMsg() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      getMeal(data).then((res) => {
        if (res.code == 200) {
          console.log("taocan", res.data);
          this.mealList = res.data;
        } else {
          this.$message(res.msg);
        }
      });
      getExpireTime(data).then((res) => {
        console.log("到期shijain", res);
        var nt = (new Date().getTime() / 1000).toFixed(0);
        this.lastTime = ((res.expire_time - nt) / 60 / 60 / 24).toFixed(0);
        this.mealName = res.meal_name;
        this.ExpireTime = res.day;
        if (this.lastTime < 0) {
          this.lastTime = 0;
        } else if (this.lastTime < 1) {
          this.lastTime = "不足1";
          this.upcoming = true;
        } else if (this.lastTime < 5) {
          this.upcoming = true;
        }
      });
    },
    // 续费收款二维码
    payQrcode(item) {
      var t = new Date().getTime();
      this.nonce = "a" + this.app_id + "t" + t;
      this.showQrcode = true;
      var baseUrl =
        this.status == "test"
          ? "http://cs.58zltc.com/api/meal/feeQrcode?"
          : "http://www.58zltc.com/api/meal/feeQrcode?";
      this.qrcode =
        baseUrl +
        "token=" +
        this.token +
        "&app_id=" +
        this.app_id +
        "&meal_id=" +
        item.id +
        "&nonce=" +
        this.nonce +
        "&return_url=https://jjtc.58zltc.com/paySuccess?";
      // 使用$nextTick确保数据渲染
      this.$nextTick(() => {
        this.crateQrcode();
      });
      this.getPayStatus();
    },
    // 生成二维码
    crateQrcode() {
      var canvas = this.$refs.qrcode;
      new QRCode(canvas, {
        width: 300,
        height: 300, // 高度
        text: this.qrcode, // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
      // console.log(this.qrcode)
    },
    // 关闭弹框,清除已经生成的二维码
    closeCode() {
      this.showQrcode = false;
      this.$refs.qrcode.innerHTML = "";
    },
    getPayStatus() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        nonce: this.nonce,
      };
      checkStatus(data).then((res) => {
        if (res.code == 200) {
          if (res.msg == "支付成功") {
            this.$message({
              type: "success",
              message: "支付成功！",
            });
            this.showQrcode = false;
            this.showRenew = false;
            this.getMealMsg();
          } else {
            setTimeout(() => {
              this.getPayStatus();
            }, 3000);
          }
        } else {
          setTimeout(() => {
            this.getPayStatus();
          }, 3000);
        }
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getdata();
      this.init();
      this.get_gonggaoList();
    });

    this.menuData = [
      {
        title: "会员积分",
        imgUrl: require("../../../../../public/img/vipImg/jifenduihuan.png"),
        url: "/apply/newVip/13/business/integral",
      },
      {
        title: "收银台",
        imgUrl: require("../../../../../public/img/vipImg/moneyshoukuan.png"),
        url: "/apply/newVip/13/business/getMoney",
      },
      {
        title: "快速充值",
        imgUrl: require("../../../../../public/img/vipImg/vipbanka.png"),
        url: "/apply/newVip/13/business/recharge",
      },
      {
        title: "客户召回",
        imgUrl: require("../../../../../public/img/vipImg/kehuzhaohui.png"),
        url: "/apply/newVip/13/home/customerBack",
      },
      {
        title: "现金待确认",
        imgUrl: require("../../../../../public/img/money.png"),
        url: "/apply/newVip/13/home/scanVerification",
      },
      {
        title: "交班",
        imgUrl: require("../../../../../public/img/vipImg/jiaoban.png"),
        url: "/apply/newVip/13/home/changeDuty",
      },
      {
        title: "电子优惠券",
        imgUrl: require("../../../../../public/img/vipImg/dianziyouhuiquan.png"),
        url: "/apply/newVip/13/market/marketing/salesPromotion/shellDiscount",
      },
      {
        title: "改油价",
        imgUrl: require("../../../../../public/img/vipImg/changePrice.png"),
        url: "/apply/newVip/13/refuel/list",
      },
      {
        title: "专车认证",
        imgUrl: require("../../../../../public/img/vipImg/car.png"),
        url: "/apply/Car/Certification",
      },
    ];
    if (this.app_id == "432" || this.app_id == "427") {
      this.show_mobile = "18765520618";
    } else {
      this.show_mobile = this.publicData.a_mobile;
    }
  },
  components: {
    Judge,
  },
};
</script>
<style lang="scss" scoped>
.gundong {
  width: 500px;
  border-radius: 5px;
  position: fixed;
  top: 55px;
  left: 35%;
  color: #fff;
  z-index: 1000;
}
.erweima {
  position: absolute;
  top: -25px;
  left: -9rem;
  width: 100px;
  height: 100px;
}
.ziti {
  position: absolute;
  left: -8.2rem;
  bottom: -35px;
}
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  // 新加
  .topBox {
    display: flex;
    justify-content: space-between;
    .topBox_left {
      width: 35.5%;
      display: flex;
      .line {
        width: 10px;
        background: #f1f2f6;
      }
      .service,
      .past {
        flex: 1;
        background: #fff;
        position: relative;
      }
      .service {
        padding: 25px 28px 0px 28px;
        .top {
          display: flex;
          height: 50%;
          border-bottom: 1px solid #eee;
          img {
            height: 40px;
            margin: 0 14px 0 6px;
          }
          .top_left {
            height: 40px;
            div:nth-child(1) {
              height: 28px;
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .bottom {
          height: 50%;
          font-size: 16px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          div {
            display: flex;
            flex: 1;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
          }
          img {
            height: 40px;
            margin: 0 14px 0 6px;
          }
        }
        .broadcast {
          position: absolute;
          top: 25px;
          right: 23px;
          width: 120px;
          height: 40px;
          text-align: center;
          // cursor: pointer;
          // border: 1px solid #409eff;
          // color: #409eff;
          // border-radius: 25px;
          // background: #;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .past {
        padding: 15px 15px 15px 25px;
        div:first-child {
          line-height: 22px;
          font-size: 16px;
          padding: 7px 0;
          font-weight: 500px;
        }
        div:nth-child(2) {
          display: flex;
          line-height: 28px;
          color: #f94522;
          padding: 6px 0;
          font-size: 14px;
          span {
            font-size: 16px;
            padding: 0 6px;
          }
          p:nth-child(2) {
            color: #666666;
          }
        }
        div:nth-child(3) {
          font-size: 12px;
        }
        div:last-child {
          width: 100%;
          height: 33px;
          line-height: 33px;
          margin-top: 12px;
          text-align: center;
          color: #fff;
          background: rgba(249, 69, 34, 1);
          border-radius: 3px;
        }
      }
    }
  }
  .shortcutMenu {
    width: 63.5%;
    background: #fff;
    padding: 20px 30px;
    .headline {
      font-size: 14px;
    }
    .menuCont {
      display: flex;
      margin-bottom: 10px;
      overflow-x: auto;
      .option {
        cursor: pointer;
        margin: 0 15px;
        margin-right: 30px;
        .el-badge {
          margin-top: 18px;
        }
        .details {
          width: 60px;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          text-align: center;
          margin-top: 5px;
        }
      }
    }
  }
  .modules {
    margin-top: 10px;
    display: flex;
    padding-bottom: 15px;
    justify-content: space-between;
    .lft {
      width: 63.5%;
      .statistics {
        width: 100%;
        padding: 20px;
        background: #fff;
        min-height: 300px;
        .headline {
          display: flex;
          justify-content: space-between;
        }

        p {
          font-size: 14px;
          padding-left: 10px;
          display: flex;
          align-items: center;
        }
        .colorFont {
          color: #2f54eb;
          margin-left: 5px;
        }
        .cont {
          margin-top: 25px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          .cont_item_box {
            width: 24%;
            height: 98px;
            margin-bottom: 10px;
            border-radius: 4px;
            border: 1px solid #dadada;
            text-align: center;
          }
          .cont_item_box2 {
            width: 49.5%;
            height: 98px;
            margin-bottom: 10px;
            border-radius: 4px;
            border: 1px solid #dadada;
            text-align: center;
          }
          .cont_item_title {
            height: 30px;
            background: #f4f4f4;
            line-height: 30px;
            font-size: 14px;
          }
          .cont_item_value {
            height: 68px;
            line-height: 68px;
            font-size: 13px;
            span {
              font-size: 24px;
              color: #2f54eb;
              margin-right: 5px;
            }
          }
          .cont_item_value2 {
            font-size: 13px;
            display: flex;
            span {
              font-size: 24px;
              color: #2f54eb;
              margin-right: 5px;
            }
            .item_value_part {
              flex: 1;
              margin-top: 8px;
            }
            .bdline {
              margin-top: 14px;
              height: 40px;
              border-right: 1px solid #ddd;
            }
          }
        }
      }
      .system {
        margin-top: 10px;
        padding: 20px 30px;
        .headline {
          margin-bottom: 8px;
        }
        .tags {
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-bottom: 0;
          margin-top: 5px;
          padding: 12px;
          .el-tag {
            color: #fff;
            margin-right: 10px;
          }
        }
      }
    }
    .rgt {
      width: 35.5%;
      .top {
        min-height: 313px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .todaysales {
          min-height: 150px;
          width: 100%;
          background: #fff;
          padding: 20px;
          .headline {
            text-align: center;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 22px;
              height: 22px;
              margin-right: 8px;
            }
          }
          .todaysales-cont {
            display: flex;
            width: 100%;
            margin-top: 15px;
            div {
              flex: 1;
              p {
                font-size: 14px;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 36px;
                img {
                  width: 16px;
                  margin-right: 5px;
                }
              }
              .colorBule {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(47, 84, 235, 1);
                line-height: 28px;
              }
            }
          }
        }
        .pay {
          p {
            height: 40px !important;
            background-size: contain !important;
            background-repeat: no-repeat !important;
            background-position: 20px !important;
          }
        }
      }
      .btm {
        padding: 20px 30px;
        background: #fff;
        margin-top: 10px;
        .headline {
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.75);
          line-height: 20px;
        }
        .smallhead {
          margin-top: 10px;
          height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 18px;
          margin-bottom: 10px;
        }
        .cont {
          display: flex;

          .ggCont {
            flex: 8;
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(102, 102, 102, 1);
            line-height: 24px;
            height: 24px;
          }
          .ggHint {
            flex: 2;
            line-height: 24px;
            height: 24px;
            text-align: right;
            color: #2f54eb;
          }
          .ggHint:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
  .meal_item_box {
    border-radius: 5px;
    border: 1px solid #ccc;
    height: 40px;
    line-height: 40px;
    margin-bottom: 12px;
    padding: 0 10px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    .meal_item_title {
      flex: 1;
      .meal_item_times {
        margin-left: 6px;
        font-size: 14px;
      }
    }
    .meal_item_price {
      color: #f94500;
    }
  }
  .meal_item_box:hover {
    border: 1px solid #409eff;
  }
}
</style>
